import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createModelCode } from '../model-code/ModelCode';

/**
 * # ChangedData
 *
 * ChangedData을 설명하세요.
 */
export const ChangedData = types
  .model('ChangedData')
  // --------------------------------------------------------------------------
  .props({
    projectHistSid: types.optional(types.number, 0),
    projectHistCd: createModelCode(),
    key: types.optional(types.string, ''),
    changeAfter: types.frozen(),
    changeBefore: types.frozen(),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model changedData --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IChangedData;
      (Object.keys(newProps) as TChangedDataKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TChangedData = Instance<typeof ChangedData>;
type TChangedDataSnapshot = SnapshotOut<typeof ChangedData>;

export interface IChangedData extends TChangedData {}
export type TChangedDataKeys = keyof TChangedDataSnapshot & string;
export interface IChangedDataSnapshot extends TChangedDataSnapshot {}
export const createChangedData = () => types.optional(ChangedData, {} as TChangedData);
